import { ConversationsContainer } from 'pages/conversations/ConversationsContainer';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getKey } from 'store/createKeyedDataAsyncSlice';
import { getActivityActionsAsyncAction } from 'store/order/activity/activityActionsSlice';
import { getActivitiesAsyncAction } from 'store/order/activity/activitySlice';
import { getActivityUsersAsyncAction } from 'store/order/activity/activityUsersSlice';
import { useAppDispatch } from 'store/store';
import { RootStore } from 'store/types';
import { IActivityData } from 'types/order/activities/IActivityData';
import { IActivityQuery } from 'types/order/activities/IActivityQuery';
import { Card, ErrorMessage, Grid, PagerWrapper } from 'ui-toolkit';
import { createDefaultPageData } from 'types/rest/IPageData';
import { ActivityTable } from './ActivityTable';

export interface IActivityLogContainerProps {
  queryKey: string;
  queryObject: IActivityQuery;
  setQueryObject: (x: IActivityQuery) => void;
}

export const ActivityLogContainer: React.FC<IActivityLogContainerProps> = ({
  queryKey,
  queryObject,
  setQueryObject,
}) => {
  const { activitySlice, activityActionsSlice, activityUsersSlice } = useSelector(
    ({ order: { activityActionsSlice, activitySlice, activityUsersSlice } }: RootStore) => ({
      activityActionsSlice,
      activitySlice,
      activityUsersSlice,
    })
  );
  const {
    data = { ...createDefaultPageData<IActivityData>(), pageNumber: 1, pageSize: 10, sortBy: 'occurredAt.asc' },
    fetchStatus,
    fetchError,
  } = getKey(queryKey, activitySlice);

  const { data: actionOptions = [] } = getKey(queryObject.orderId, activityActionsSlice);
  const { data: userOptions = [] } = getKey(queryObject.orderId, activityUsersSlice);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getActivityActionsAsyncAction({ orderId: queryObject.orderId }));
    dispatch(getActivityUsersAsyncAction({ orderId: queryObject.orderId }));
  }, [queryObject.orderId, dispatch]);
  useEffect(() => {
    dispatch(getActivitiesAsyncAction(queryObject));
  }, [queryObject, dispatch]);

  return (
    <Grid>
      <ConversationsContainer orderId={queryObject.orderId} />
      <Card title={'Activity Feed'}>
        <Grid>
          <ErrorMessage error={fetchError} />
          <PagerWrapper
            total={data.totalElements}
            page={data.pageNumber}
            pageSize={data.pageSize}
            onPageChange={(pageNumber) => setQueryObject({ ...queryObject, pageNumber })}
            onPageSizeChange={(pageSize) => setQueryObject({ ...queryObject, pageSize })}
          >
            <ActivityTable
              queryObject={queryObject}
              queryData={data}
              queryFetchStatus={fetchStatus}
              setQueryObject={setQueryObject}
              actionOptions={actionOptions}
              userOptions={userOptions}
            />
          </PagerWrapper>
        </Grid>
      </Card>
    </Grid>
  );
};
